import React, { Component } from 'react';
import { REACT_APP_API_BASE } from '../config';

const Container = (WrappedComponent) => {
    class WithRoles extends Component {

        state = {
            isLoadingRoles: true,
            roles: null,
            isError: false
        };

        async fetchMenu() {
            const token = await this.props.getAccessToken();
            
            const headers = new Headers();
            const bearer = `Bearer ${token}`;
            headers.append('Authorization', bearer);
            
            const options = {
                method: 'GET',
                headers: headers,
            };

            return await fetch(`${REACT_APP_API_BASE}/online/menu`, options);
        }

        async refreshMenu() {
            const res = await this.fetchMenu();
            if (res.ok) {
                const roles = await res.json();
                this.setState({
                    roles,
                    isLoadingRoles: true
                });
            } else {
                this.setState({
                    isError: true,
                    isLoadingRoles: false
                })
            }
        }
        
        async componentDidUpdate() {
            if (!this.props.isAuthenticated) return;

            if (this.state.roles) return;

            if (this.state.isError)  return;

           const res = await this.fetchMenu();
            if (res.ok) {
                const roles = await res.json();
                this.setState({
                    roles,
                    isLoadingRoles: true
                });
            } else {
                this.setState({
                    isError: true,
                    isLoadingRoles: false
                })
            }
        }

        render() {
            return (
                <WrappedComponent {...this.props} {...this.state} refreshMenu={() => this.refreshMenu()} />
            );
        }
    }

    return WithRoles;
}
export default Container;
